import React, {Component} from 'react';
import './StepPersonalData.css';
import VerifyDataForm from "./VerifyDataFormOldUnused";
import AddPersonalDataForm from "./AddPersonalDataForm";
import VerifySSNUser from "./VerifySSNUser";
import GlobalStore from "../../store/GlobalStore";

class StepPersonalData extends Component {
    constructor(props) {
        GlobalStore.getInstance().data['currentStep'] = 3;
        super();
        this.openVerifySSNUser = this.openVerifySSNUser.bind(this);
        this.openAddPersonalDataForm = this.openAddPersonalDataForm.bind(this);
        this.state = {
            stepPersonalDataProcessor: 'verifySSNUser',
        };
    }

    showStep() {
        switch (this.state.stepPersonalDataProcessor) {
            case 'verifyDataForm':
                return (
                    <VerifyDataForm previousStep={this.props.previousStep} openVerifySSNUser={this.openVerifySSNUser}/>
                );
            case 'verifySSNUser':
                return (
                    <VerifySSNUser openAddPersonalDataForm={this.openAddPersonalDataForm} nextStep={this.props.nextStep}
                                   previousStep={this.props.previousStep}/>
                );
            case 'addPersonalDataForm':
                return (
                    <AddPersonalDataForm nextStep={this.props.nextStep}/>
                );
        }
    }

    openVerifySSNUser() {
        this.setState({
            stepPersonalDataProcessor: 'verifySSNUser'
        });
    }

    openAddPersonalDataForm() {
        this.setState({
            stepPersonalDataProcessor: 'addPersonalDataForm'
        });
    }

    render() {
        return (
            <div className="stepPersonalContainer col-xs-12">
                {this.showStep()}
            </div>
        );
    }
}

export default StepPersonalData;



// WEBPACK FOOTER //
// ./src/components/Step_4/StepPersonalData.jsx